/* import __COLOCATED_TEMPLATE__ from './team-capacity-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';
import type OfficeHoursSchedule from 'embercom/models/office-hours-schedule';

interface Signature {
  Args: {
    predicate: any; // predicate is not typed yet
    predicateContext: { officeHoursSchedule: OfficeHoursSchedule; isImplicitPredicate: boolean };
    changePredicateValue: (event: Event) => void;
    changePredicateComparison: (value: string) => void;
    mode: string;
  };
}

const TeamCapacityEditor = templateOnlyComponent<Signature>();
export default TeamCapacityEditor;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Predicates::Editors::TeamCapacityEditor': typeof TeamCapacityEditor;
  }
}
